import { Badge, NumberFormatter } from "@mantine/core";

import classes from "./ProductList.module.css";

export default function QualityBadge({ score }) {
  let color = "green";
  if (score < 0.6) {
    color = "red";
  } else if (score < 0.8) {
    color = "yellow";
  }
  return (
    <Badge
      variant="dot"
      color={color}
      classNames={{ label: classes.badgeLabel }}
    >
      <NumberFormatter value={score * 100} suffix=" %" decimalScale={0} />
    </Badge>
  );
}
